module.exports = __webpack_public_path__ + "img/tongji.7544383c.png";